import { createSelector } from 'reselect';
import _ from 'lodash';

import { RootState } from '..';

export const selectSettings = (state: RootState) => {
  return state.settings;
};

export const selectLang = (state: RootState) => {
  return state.settings.lang;
};

export const selectGeneralSettings = (state: RootState) => {
  return state.settings.general;
};

export const selectTexts = createSelector(selectSettings, selectLang, (settings, lang) => {
  return settings.texts[lang];
});

export const selectLoginTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'logIn', {});
});

export const selectGeneralTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'general', {});
});

export const selectCoverTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'cover', {});
});

export const selectFormTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'form', {});
});

export const getSeoTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'seo', {});
});

export const getPopUpTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'popUp', {});
});
